import { useCallback, useEffect } from 'react';
import { useToggle } from '@direct-frontend/stdlib';
import { useGetOnboardingStages } from '#shared/api/onboarding';
import { useNavigateWithSearchParams } from '#shared/lib/router';
import { designRoute } from '#shared/lib/routes';
import { usePersistentStorage } from '#shared/lib/storage';
import { trackGoal } from '#shared/lib/trackGoal';
import { ONBOARDING_WELCOME_MODAL_SHOWN } from '../../lib/goals';
import { WelcomeModal } from '../WelcomeModal';

export function KitWelcomeModal() {
    const navigate = useNavigateWithSearchParams();
    const { data } = useGetOnboardingStages();
    const { value: isOpen, toggleOff: close, toggleOn: open } = useToggle();
    const [hasSeenWelcomeModal, setHasSeenWelcomeModal] = usePersistentStorage<'1'>('onboarding.hasSeenWelcomeModal');
    const hasStartedOnboarding = data?.stages.some((stage) => stage.is_completed);

    useEffect(() => {
        if (!data) {
            return;
        }

        if (hasStartedOnboarding) {
            return;
        }

        if (hasSeenWelcomeModal) {
            return;
        }

        open();
        trackGoal(ONBOARDING_WELCOME_MODAL_SHOWN);
        setHasSeenWelcomeModal('1');
    }, [data, hasSeenWelcomeModal, hasStartedOnboarding, open, setHasSeenWelcomeModal]);

    const handleClickWelcome = useCallback(() => {
        close();
        navigate(designRoute.getUrl());
    }, [close, navigate]);

    return <WelcomeModal isOpen={isOpen} onClose={close} onClick={handleClickWelcome} />;
}
